<template>
    <div>
        <b-overlay :show="loading" rounded="sm">
            <div v-if="LikeFollowDetail" class="lf-container">
            <div :class="['lf-tray', { 'lf-mobile': mobile }]">
                <!-- Title (match Figma: "J*** D** from HONG KONG (CHINA)" + Unread, right: liked on + ref) -->
                <div class="lf-title-row">
                    <div class="lf-title-left">
                        <i v-if="mobile" class="lf-back" @click="$emit('close')">
                            <img src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/SalesLead_Back_Arrow.svg" alt="返回" width="24" height="25" />
                        </i>

                        <div class="lf-title-line">
                            <span class="lf-title-text">{{ title }}</span>
                            <span class="lf-unread-chip" v-if="unread">{{ $t("lbl_EMPBE_SalesLead_Unread") }}</span>
                            <span class="lf-viewed" :class="{ 'is-unlocked': isQuotaUnlocked }" v-else-if="viewedOnText">
                                <img
                                    v-if="isQuotaUnlocked"
                                    class="lf-viewed__lock"
                                    :src="unlockedChipLockImg"
                                    width="15"
                                    height="16"
                                    alt=""
                                />
                                <span>{{ viewedOnText }}</span>
                            </span>
                        </div>
                    </div>

                    <div class="lf-title-right">
                        <span class="lf-received">{{ likedOnText }}</span>
                        <TipsAndPrivewDilog
                            v-if="visibilityTipText && simulatedSupplier"
                            class="lf-visibility-tip"
                            :id="`SalesLead_LikeFollow_VisibilityTip_${rid || 0}`"
                            :Title="visibilityTipText"
                        >
                            <template v-slot:Text></template>
                        </TipsAndPrivewDilog>
                        <span class="lf-ref">{{ refText }}</span>
                    </div>
                </div>

                <!-- Unlock bar：受限展台且本条未解锁/未豁免时才显示 -->
                <div class="lf-unlock" v-if="showUnlockBanner" v-show="isContactLocked">
                    <unlockQuota_Free
                        ref="likeFollowUnlockQuota"
                        :key="`bookmark-unlock-${rid || 0}-${unlockQuotaRefreshKey}`"
                        Type="2"
                        unlockType="Bookmark"
                        :user="user"
                        :rid="rid"
                        :mobile="mobile"
                        :simulatedSupplier="simulatedSupplier"
                        @unlockQuota="onLikeFollowUnlockQuota"
                        @unlockQuotaInfo="onLikeFollowUnlockQuotaInfo"
                    />
                </div>

                <!-- Content -->
                <div class="lf-content">
                    <div class="lf-content-inner">
                        <div class="lf-master">
                            <!-- Liked target: show product first, fallback to company -->
                            <div class="lf-section" v-if="likedTarget">
                                <div class="lf-section-title">{{ likedTargetTitle }}</div>
                                <div
                                    class="lf-card"
                                    :class="{ 'lf-card--clickable': !!likedTargetTargetUrl }"
                                    @click="openLikedTargetLink"
                                >
                                    <div
                                        v-if="likedTarget.isProduct"
                                        class="lf-product"
                                    >
                                        <div class="lf-product-thumb">
                                            <img :src="likedTarget.thumbUrl" alt="Product" />
                                        </div>
                                        <div class="lf-product-title">
                                            <span class="lf-product-title-text">{{ likedTarget.name }}</span>
                                            <a
                                                v-if="productShareUrl"
                                                :href="productShareUrl"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                :t_label="`EMP3_SalesLead_LikeFollow_ProductShare_${rid || 0}`"
                                                @click.stop
                                            >
                                                <img src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/open_in_new.svg" alt="Share" width="16" height="16" />
                                            </a>
                                        </div>
                                    </div>
                                    <div v-else class="lf-product">
                                        <div class="lf-product-thumb lf-product-thumb--company">
                                            <img v-if="companyLogoUrl" :src="companyLogoUrl" alt="Company" />
                                            <span v-else class="lf-company-thumb-fallback">{{ likedCompanyFirstChar }}</span>
                                        </div>
                                        <div class="lf-product-title">
                                            <span class="lf-product-title-text">{{ likedTarget.name }}</span>
                                            <a
                                                v-if="companyShareUrl"
                                                :href="companyShareUrl"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                :t_label="`EMP3_SalesLead_LikeFollow_CompanyShare_${rid || 0}`"
                                                @click.stop
                                            >
                                                <img src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/open_in_new.svg" alt="Share" width="16" height="16" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Your Actions -->
                            <div class="lf-section">
                                <div class="lf-section-title">{{ $t("lbl_EMPBE_SalesLead_LikeFollow_YourActions") }}</div>
                                <div class="lf-card">
                                    <div class="lf-actions-row" v-if="showActionSendButton">
                                        <button
                                            v-if="showUnlockToSendInvitation && !simulatedSupplier"
                                            type="button"
                                            class="lf-actions-btn lf-actions-btn-unlock"
                                            :t_label="`EMP3_SalesLead_LikeFollow_UnlockToSendInvitation_${rid || 0}`"
                                            @click="openLikeFollowUnlockDialog"
                                        >
                                            <span class="lf-actions-btn-icon">
                                                <img src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/SalesLead_Lock.svg" alt="" width="20" height="20" />
                                            </span>
                                            <span>{{ $t('lbl_EMPBE_SalesLead_UnlockToSendInvitation') }}</span>
                                        </button>
                                        <button
                                            v-else
                                            type="button"
                                            class="lf-actions-btn"
                                            :class="{ 'lf-actions-btn-no-quota': isSendInvitationDisabled }"
                                            :disabled="isSendInvitationDisabled"
                                            :t_label="`EMP3_SalesLead_LikeFollow_SendInvitation_${rid || 0}`"
                                            @click="onSendInvitation"
                                        >
                                            {{ sendInvitationBtnText }}
                                        </button>
                                        <span class="lf-actions-slash">/</span>
                                        <span class="lf-actions-tip">{{ actionDescText }}</span>
                                    </div>
                                    <button
                                        v-else
                                        type="button"
                                        class="lf-actions-btn lf-actions-btn-status"
                                        :class="[`lf-status-${actionStatusNormalized}`]"
                                        @click="onActionStatusClick"
                                    >
                                        <span class="lf-status-icon" aria-hidden="true">
                                            <img
                                                v-if="actionStatusNormalized === 'accept'"
                                                src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/SalesLead_LikeFollow_Status_Accepted.svg"
                                                alt=""
                                                width="20"
                                                height="20"
                                            />
                                            <img
                                                v-else-if="actionStatusNormalized === 'pending'"
                                                src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/SalesLead_LikeFollow_Status_Pending.svg"
                                                alt=""
                                                width="20"
                                                height="20"
                                            />
                                            <img
                                                v-else
                                                src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/SalesLead_LikeFollow_Status_Rejected.svg"
                                                alt=""
                                                width="20"
                                                height="20"
                                            />
                                        </span>
                                        <span class="lf-status-text">{{ actionBadgeText }}</span>
                                    </button>
                                    <div v-if="actionMetaText" class="lf-actions-meta">{{ actionMetaText }}</div>
                                </div>
                            </div>
                        </div>

                        <!-- Right: Contact info -->
                        <div class="lf-contact">
                            <div class="lf-section">
                                <div class="lf-section-title">{{ $t("lbl_EMPBE_SalesLead_LikeFollow_ContactInfo") }}</div>
                                <div class="lf-card">
                                    <div class="lf-contact-tip" v-if="showContactHiddenHint">
                                        <svg class="lf-contact-tip__icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                                            <path d="M2.667 3.333h10.666c.737 0 1.334.597 1.334 1.334v6.666c0 .737-.597 1.334-1.334 1.334H2.667c-.737 0-1.334-.597-1.334-1.334V4.667c0-.737.597-1.334 1.334-1.334z" stroke="currentColor" stroke-width="1.2"/>
                                            <path d="M14.667 4.667L8 9.333 1.333 4.667" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        <span class="lf-contact-tip__text">{{ $t("lbl_EMPBE_SalesLead_LikeFollow_ContactHiddenHint") }}</span>
                                    </div>
                                    <div v-if="shouldShowRiskAlert" class="lf-risk-note">
                                        <div class="lf-risk-note-title">{{ $t("lbl_EMPBE_SalesLead_LikeFollow_RiskNote_Title") }}</div>
                                        <div class="lf-risk-note-text">{{ $t("lbl_EMPBE_SalesLead_LikeFollow_RiskNote_Body") }}</div>
                                    </div>
                                    <div class="lf-contact-list">
                                        <div class="lf-row" v-if="contact.companyName">
                                            <div class="lf-row-label">{{ $t("lbl_EMPBE_SalesLead_CompanyName") }}</div>
                                            <div class="lf-row-value">{{ contact.companyName }}</div>
                                        </div>
                                        <div class="lf-row" v-if="contact.fullName">
                                            <div class="lf-row-label">{{ $t("lbl_EMPBE_SalesLead_FullName") }}</div>
                                            <div class="lf-row-value">{{ contact.fullName }}</div>
                                        </div>
                                        <div class="lf-row" v-if="contact.jobTitle">
                                            <div class="lf-row-label">{{ $t("lbl_EMPBE_SalesLead_JobTitle") }}</div>
                                            <div class="lf-row-value">{{ contact.jobTitle }}</div>
                                        </div>
                                        <div class="lf-row" v-if="contact.countryRegion">
                                            <div class="lf-row-label">{{ $t("lbl_EMPBE_SalesLead_Country") }}</div>
                                            <div class="lf-row-value">{{ contact.countryRegion }}</div>
                                        </div>
                                        <div class="lf-row" v-if="contact.mobile">
                                            <div class="lf-row-label">{{ $t("lbl_EMPBE_SalesLead_MobileNumber") }}</div>
                                            <div class="lf-row-value">{{ contact.mobile }}</div>
                                        </div>
                                        <div class="lf-row">
                                            <div class="lf-row-label">{{ $t("lbl_EMPBE_SalesLead_EmailAddress") }}</div>
                                            <div class="lf-row-value">{{ contactEmailDisplay }}</div>
                                        </div>
                                    </div>
                                    <div class="lf-contact-foot" v-if="showContactHiddenHint">{{ $t("lbl_EMPBE_SalesLead_LikeFollow_ContactFoot") }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="lf-remarks" v-if="rid">
                <MessageThread
                    :key="'remarks-likefollow-' + rid"
                    :source-type="'LikeFollow'"
                    :source-id="rid"
                    log-form-type-prefix="SalesleadBack_"
                    :simulated-supplier="!!simulatedSupplier"
                    :max-depth="5"
                    :allow-create="true"
                    :allow-reply="false"
                    :allow-delete="false"
                    :root-level-only="true"
                />
            </div>
            </div>
        </b-overlay>

        <!-- Modal: Send Contact Exchange Invitation (mirror NameCard modal structure) -->
        <ModalTips :id="'SendInvitationModal'" v-model="showSendInvitationModal">
        <template v-slot:Title>
            <div v-if="isInvitationEditable" class="lf-modal-title">
                <div class="lf-modal-title-text">{{ $t("lbl_EMPBE_SalesLead_LikeFollow_SendInvitation_Title") }}</div>
                <div class="lf-modal-subtitle">{{ $t("lbl_EMPBE_SalesLead_LikeFollow_SendInvitation_Subtitle") }}</div>
                <button
                    type="button"
                    class="lf-modal-close"
                    @click="showSendInvitationModal = false"
                    aria-label="Close"
                    :t_label="`EMP3_SalesLead_LikeFollow_SendInvitationModal_Close_${rid || 0}`"
                >
                    <img src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/SalesLead_Close.svg" alt="Close" width="24" height="24" />
                </button>
            </div>
            <div v-else class="lf-modal-record-title">
                <div class="lf-modal-record-main">
                    <div class="lf-modal-title-text">{{ $t("lbl_EMPBE_SalesLead_LikeFollow_InvitationRecord_Title") }}</div>
                    <span :class="['lf-modal-status-tag', `lf-status-${actionStatusNormalized}`]">{{ modalStatusText || '-' }}</span>
                </div>
                <button
                    type="button"
                    class="lf-modal-close"
                    @click="showSendInvitationModal = false"
                    aria-label="Close"
                    :t_label="`EMP3_SalesLead_LikeFollow_SendInvitationModal_Close_${rid || 0}`"
                >
                    <img src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/SalesLead_Close.svg" alt="Close" width="24" height="24" />
                </button>
            </div>
        </template>

        <template v-slot:Content>
            <div class="lf-modal-body">
                <div v-if="shouldShowRiskAlert" class="lf-risk-note lf-risk-note-modal">
                    <div class="lf-risk-note-title">{{ $t("lbl_EMPBE_SalesLead_LikeFollow_RiskNote_Title") }}</div>
                    <div class="lf-risk-note-text">{{ $t("lbl_EMPBE_SalesLead_LikeFollow_RiskNote_Body") }}</div>
                </div>
                <div class="lf-modal-block">
                    <selection style="margin-bottom:0px !important;"
                        ControlId="lfContactPerson"
                        :title="$t('lbl_EMPBE_SalesLead_LikeFollow_SelectContact')"
                        :mandatory="$t('lbl_EMPBE_SalesLead_LikeFollow_SelectContact') + $t('lbl_IsRequire')"
                        v-model="selectedContactPerson"
                        :options="contactPersonOptions"
                        :enableValidation="contactPersonLoaded"
                        :disabled="contactPersonLoading || !isInvitationEditable"
                        :clearable="false"
                        :searchable="false"
                        :allowInput="false"
                        :appendToBody="true"
                        :zIndex="3000"
                    />
                    <div v-if="isInvitationEditable" class="lf-modal-hint">
                        {{ $t("lbl_EMPBE_SalesLead_LikeFollow_NoContactHint_Part1") }}<router-link
                            class="lf-modal-link"
                            :to="{ path: '/UserSetting/MyUsers' }"
                            :t_label="`EMP3_SalesLead_LikeFollow_GoUserManagement_${rid || 0}`"
                        >{{ $t("lbl_EMPBE_SalesLead_LikeFollow_UserManagement") }}</router-link>{{ $t("lbl_EMPBE_SalesLead_LikeFollow_NoContactHint_Part2") }}
                    </div>
                </div>

                <!-- Company profile preview -->
                <div class="lf-modal-profile">
                    <div class="lf-modal-profile-title">{{ $t("lbl_EMPBE_SalesLead_LikeFollow_ProfileAndMessage") }}</div>
                    <div class="lf-modal-profile-card">
                        <div class="lf-modal-profile-left">
                            <div class="lf-modal-logo">
                                <img
                                    v-if="replyModalLogoUrl"
                                    :src="replyModalLogoUrl"
                                    alt="logo"
                                    width="56"
                                    height="56"
                                />
                                <span v-else class="lf-modal-logo-fallback">{{ replyModalCompanyFirstChar }}</span>
                            </div>
                        </div>
                        <div class="lf-modal-profile-right">
                            <div class="lf-modal-company">{{ replyModalCompanyName }}</div>
                            <div v-if="replyModalCompanyDesc" class="lf-modal-company-desc">
                                {{ replyModalCompanyDesc }}
                            </div>
                        </div>
                    </div>

                    <div v-if="isInvitationEditable" class="lf-modal-block">
                        <customtextarea autocomplete="off" 
                            ref="lfMessageToBuyerTextarea"
                            ControlId="lfMessageToBuyer"
                            :placeholderOnTop="true"
                            :class="['lf-message-input', { 'lf-message-input--expanded': isMessageOverOneLine }]"
                            rows="1"
                            style="font-size: 14px;"
                            v-model="messageToBuyer"
                            max="500"
                            :placeholder="$t('lbl_EMPBE_SalesLead_LikeFollow_MessageToBuyer')"
                            :customErrorMessage="{ max: $t('lbl_EMPBE_PIG_InputExceedLimit') }"
                        />
                    </div>
                    <div v-else class="lf-modal-block">
                        <div class="lf-modal-readonly-title">{{ $t('lbl_EMPBE_SalesLead_LikeFollow_MessageToBuyer') }}</div>
                        <div class="lf-modal-readonly-value">{{ readonlyMessageToBuyer }}</div>
                    </div>

                    <div v-if="isInvitationEditable  && false" class="lf-modal-info-note">
                        {{ $t("lbl_EMPBE_SalesLead_LikeFollow_InvitationModal_InfoNote_Part1") }}<router-link
                            class="lf-modal-link"
                            :to="{ path: '/UserSetting/MyUsers' }"
                            :t_label="`EMP3_SalesLead_LikeFollow_InfoNote_UserManagement_${rid || 0}`"
                        >{{ $t("lbl_EMPBE_SalesLead_LikeFollow_UserManagement") }}</router-link>{{ $t("lbl_EMPBE_SalesLead_LikeFollow_InvitationModal_InfoNote_Part2") }}
                    </div>

                    <checkbox
                        v-if="isInvitationEditable && false"
                        v-model="saveAsDefaultMessage"
                        class="lf-modal-save"
                        :t_label="`EMP3_SalesLead_LikeFollow_SaveDefaultMessage_${rid || 0}`"
                    >
                        {{ $t("lbl_EMPBE_SalesLead_LikeFollow_SaveAsDefaultMessage") }}
                    </checkbox>

                </div>
            </div>
        </template>

        <!-- <template v-slot:MiddleFooter>
            <b-button
                variant="outline-secondary"
                class="UserSetting_Cancel"
                :t_label="`EMP3_SalesLead_LikeFollow_SendInvitationModal_Cancel_${rid || 0}`"
                @click="showSendInvitationModal = false"
            >
                {{ $t("lbl_EMPBE_SalesLead_SendNameCard_Cancel") }}
            </b-button>
        </template> -->

        <template v-if="isInvitationEditable" v-slot:RightFooter>
            <b-button style="height: 40px;display: flex;align-items: center;"
                variant="primary"
                class="UserSetting_Ok"
                :disabled="!selectedContactPerson || replySubmitting"
                :t_label="`EMP3_SalesLead_LikeFollow_SendInvitationModal_Send_${rid || 0}`"
                @click="confirmSendInvitation"
            >
                {{ $t("lbl_EMPBE_SalesLead_LikeFollow_Send") }}
            </b-button>
        </template>
        </ModalTips>
    </div>
</template>

<script>
  import unlockQuota_Free from './unlockQuota_Free.vue';
  import ModalTips from '@/components/UserSetting/ModalTips.vue';
  import checkbox from '@/components/form/checkbox.vue';
  import MessageThread from '@/components/MessageBoard/MessageThread.vue';
  import { InquiryFormService } from '../../../_services';
  import { formatSalesLeadDate, formatSalesLeadViewedDate, isSalesLeadUnreadDate } from '@/_helpers/formatSalesLeadDate';
  import { formatSalesLeadTitleWithCountry } from '@/_helpers/formatSalesLeadTitleWithCountry';
  export default {
    components: {
      unlockQuota_Free,
      ModalTips,
      checkbox,
      MessageThread
    },
    inject: ['permissionData', 'GetDetail'],
    props: {
      LikeFollowDetail: Object,
      loading: Boolean,
      user: Object,
      rid: Number,
      mobile: Boolean,
      simulatedSupplier: Boolean,
    },
    data() {
      return {
        // Same convention as NameCard: true only when "still locked AND yearRemainingQuota == 0"
        isLockedByQuota: false,
        /** 当前条目是否仍锁定（来自 unlockQuotaInfo.isLock） */
        isContactLocked: true,
        bookmarkYearRemainingQuota: null,
        bookmarkEveryYearQuota: null,
        unlockQuotaRefreshKey: 0,
        showSendInvitationModal: false,
        selectedContactPerson: null,
        contactPersonOptionsData: [],
        contactPersonMap: {},
        contactPersonLoaded: false,
        contactPersonLoading: false,
        replyModalInfoLoading: false,
        replyModalInfo: null,
        replySubmitting: false,
        messageToBuyer: '',
        saveAsDefaultMessage: true,
        isMessageOverOneLine: false,
      };
    },
    computed: {
      BoothType() {
        return this.permissionData?.value?.Type || this.permissionData?.Type || '';
      },
      /** 以后端 NeedsUnlockFlow（详情 isFreeBooth）为准；过渡期内 Basic 无限时不显示解锁条 */
      isUnlockQuotaBooth() {
        const d = this.LikeFollowDetail || {};
        if (typeof d.isFreeBooth !== 'undefined') {
          return d.isFreeBooth === 1 || d.isFreeBooth === true;
        }
        return ['Guest', 'Member'].includes(this.BoothType);
      },
      /** 需挂载额度组件（含已解锁，以便用 unlockQuotaList 判断绿标） */
      showUnlockBanner() {
        return this.isUnlockQuotaBooth && !this.visibilityTipText;
      },
      /** 本条已在额度解锁名单中 */
      isQuotaUnlocked() {
        return this.showUnlockBanner && !this.isContactLocked;
      },
      isLeadUnlocked() {
        const v = this.LikeFollowDetail?.isUnLocked;
        return v === 1 || v === true || v === '1';
      },
      unread() {
        const d = this.LikeFollowDetail || {};
        return isSalesLeadUnreadDate(d.readDate || d.ReadDate);
      },
      unlockedChipLockImg() {
        const base = process.env.BASE_URL || '/';
        return `${base}img/epo-saleslead-unlocked-chip-lock.svg`;
      },
      viewedOnText() {
        const date = formatSalesLeadViewedDate(this.LikeFollowDetail);
        if (!date) return '';
        if (this.isQuotaUnlocked) {
          return this.$t('lbl_EMPBE_SalesLead_UnlockedOn', { viewedDate: date });
        }
        return this.$t('lbl_EMPBE_SalesLead_ViewedOn', { viewedDate: date });
      },
      title() {
        const d = this.LikeFollowDetail || {};
        const buyerName = d.buyerNameMasked || d.buyerName || '';
        let buyerCountry = '';
        switch (String(this.langId)) {
          case '950':
            buyerCountry = d.CountryName_trad || d.countryName_trad || '';
            break;
          case '1252':
            buyerCountry = d.CountryName_eng || d.countryName_eng || '';
            break;
          default:
            buyerCountry = d.CountryName_simp || d.countryName_simp || '';
            break;
        }
        if (!buyerCountry) buyerCountry = d.countryRegion || '';
        return formatSalesLeadTitleWithCountry(this, 'lbl_EMPBE_SalesLead_LikeFollow_BuyerTitle', { buyerName, buyerCountry });
      },
      likedOnText() {
        const d = this.LikeFollowDetail || {};
        const date = formatSalesLeadDate(d.cdate || '');
        if (!date) return '';
        const key = this.likedTarget && this.likedTarget.isProduct
          ? 'lbl_EMPBE_SalesLead_LikeFollow_LikedOn'
          : 'lbl_EMPBE_SalesLead_LikeFollow_FollowedOn';
        return this.$t(key).replace('{date}', date);
      },
      visibilityTipText() {
        const d = this.LikeFollowDetail || {};
        const raw = d.visibilityReason || d.VisibilityReason || '';
        const reason = String(raw).toUpperCase();
        if (reason === 'TRANSITION') {
          return this.$t('lbl_EMPBE_SalesLead_VisibilityTip_Transition');
        }
        if (reason === 'PAID') {
          return this.$t('lbl_EMPBE_SalesLead_VisibilityTip_Paid');
        }
        return '';
      },
      refText() {
        const d = this.LikeFollowDetail || {};
        const ref = d.eventCode || d.EventCode || d.refNo || d.RefNo || '';
        if (!ref) return '';
        return this.$t('lbl_EMPBE_SalesLead_LikeFollow_RefNo').replace('{refNo}', ref);
      },
      product() {
        const d = this.LikeFollowDetail || {};
        if (d.product) return d.product;
        const productId = Number(d.empProductId ?? d.EmpProductId ?? 0);
        if (!(productId > 0)) return null;
        return {
          id: productId,
          name: d.productName || d.ProductName || '',
          thumbUrl: d.productPhoto || d.ProductPhoto || ''
        };
      },
      productShareUrl() {
        const productId = this.LikeFollowDetail?.empProductId || this.product?.id;
        const companyId = this.user?.empCompanyId || this.LikeFollowDetail?.empCompanyId;
        if (!productId || !companyId) return null;

        let langSegment = 'simp';
        switch (String(this.langId)) {
          case '950':
            langSegment = 'trad';
            break;
          case '1252':
            langSegment = 'eng';
            break;
          default:
            langSegment = 'simp';
            break;
        }

        const base = process.env.VUE_APP_EMP_VIEW || 'https://www.chinaplasonline.com/eMarketplace';
        return `${base}/ProductInfo/${langSegment}?compid=${companyId}&SeqId=${productId}`;
      },
      likedTarget() {
        const p = this.product;
        if (p && Number(p.id) > 0) {
          return {
            isProduct: true,
            name: p.name || '',
            thumbUrl: p.thumbUrl || 'https://cdn.adsalecdn.com/EMP/2-0/NameCard/SalesLead_Image_Placeholder.svg'
          };
        }
        const d = this.LikeFollowDetail || {};
        const u = this.user || {};
        const en = u.companyNameEn || '';
        const sc = u.companyNameSc || '';
        const tc = u.companyNameTc || '';
        const companyNameByLang =
          String(this.langId) === '1252'
            ? (en || sc || tc || u.displayName || '')
            : String(this.langId) === '950'
              ? (tc || sc || en || u.displayName || '')
              : (sc || tc || en || u.displayName || '');
        const companyName = companyNameByLang || d.compname || '';
        if (!companyName) return null;
        return {
          isProduct: false,
          name: companyName,
          /* 无 Logo 时不占位图，由模板显示公司名首字（对齐 InquiryForm EnquiryFormHeader_Photo） */
          thumbUrl: this.companyLogoUrl || '',
          url: ''
        };
      },
      likedTargetTitle() {
        return this.likedTarget?.isProduct
          ? this.$t('lbl_EMPBE_SalesLead_LikeFollow_LikedYourProduct')
          : this.$t('lbl_EMPBE_SalesLead_LikeFollow_FollowedYourCompany');
      },
      invite() {
        return (this.LikeFollowDetail && this.LikeFollowDetail.invite) || {};
      },
      actionStatusNormalized() {
        const raw = String(this.LikeFollowDetail?.status || this.invite?.status || '').trim().toUpperCase();
        if (raw === 'PENDING') return 'pending';
        if (raw === 'ACCEPT' || raw === 'ACCEPTED') return 'accept';
        if (raw === 'REJECT' || raw === 'REJECTED') return 'reject';
        return 'new';
      },
      actionStatusDate() {
        const d = this.LikeFollowDetail || {};
        const raw = d.buyerActionDate || d.actionDate || d.requestDate || d.inviteDate || d.cdate || '';
        return formatSalesLeadDate(raw);
      },
      actionDescText() {
        switch (this.actionStatusNormalized) {
          case 'pending':
            return this.$t('lbl_EMPBE_SalesLead_LikeFollow_ActionDesc_Pending');
          case 'accept':
            return this.$t('lbl_EMPBE_SalesLead_LikeFollow_ActionDesc_Accept');
          case 'reject':
            return this.$t('lbl_EMPBE_SalesLead_LikeFollow_ActionDesc_Reject');
          default:
            return this.$t('lbl_EMPBE_SalesLead_LikeFollow_ActionsDesc');
        }
      },
      actionBadgeText() {
        switch (this.actionStatusNormalized) {
          case 'pending':
            return this.$t('lbl_EMPBE_SalesLead_LikeFollow_ActionBadge_Pending');
          case 'accept':
            return this.$t('lbl_EMPBE_SalesLead_LikeFollow_ActionBadge_Accept');
          case 'reject':
            return this.$t('lbl_EMPBE_SalesLead_LikeFollow_ActionBadge_Reject');
          default:
            return '';
        }
      },
      modalStatusText() {
        switch (this.actionStatusNormalized) {
          case 'pending':
            return this.$t('lbl_EMPBE_SalesLead_LikeFollow_ListStatus_Pending');
          case 'accept':
            return this.$t('lbl_EMPBE_SalesLead_LikeFollow_ListStatus_Accept');
          case 'reject':
            return this.$t('lbl_EMPBE_SalesLead_LikeFollow_ListStatus_Reject');
          default:
            return this.actionBadgeText;
        }
      },
      actionMetaText() {
        const date = this.actionStatusDate;
        if (!date || this.actionStatusNormalized === 'new') return '';
        switch (this.actionStatusNormalized) {
          case 'pending':
            return this.$t('lbl_EMPBE_SalesLead_LikeFollow_ActionMeta_SentOn')
              .replace('{date}', date)
              .replace('{invitationSentDate}', date);
          case 'accept':
            return this.$t('lbl_EMPBE_SalesLead_LikeFollow_ActionMeta_AcceptedOn')
              .replace('{date}', date)
              .replace('{invitationAcceptedDate}', date);
          case 'reject':
            return this.$t('lbl_EMPBE_SalesLead_LikeFollow_ActionMeta_RejectedOn')
              .replace('{date}', date)
              .replace('{invitationAcceptedDate}', date);
          default:
            return '';
        }
      },
      showActionSendButton() {
        return this.actionStatusNormalized === 'new';
      },
      /** 与名片一致：顶部可解锁时，底部显示「解锁以发送邀请」并走同一解锁弹窗 */
      showUnlockToSendInvitation() {
        if (!this.showActionSendButton) return false;
        if (!this.showUnlockBanner) return false;
        if (this.isLeadUnlocked) return false;
        if (!this.isContactLocked) return false;
        if (this.isLockedByQuota) return false;
        if (this.bookmarkYearRemainingQuota !== null
            && Number(this.bookmarkYearRemainingQuota) <= 0) {
          return false;
        }
        return true;
      },
      isInvitationEditable() {
        return this.actionStatusNormalized === 'new';
      },
      readonlyMessageToBuyer() {
        const msg = (this.replyModalInfo && this.replyModalInfo.lastReplyMessage) || this.messageToBuyer || '';
        return String(msg || '').trim() || '—';
      },
      contact() {
        const d = this.LikeFollowDetail || {};
        const nested = d.contact && typeof d.contact === 'object' ? d.contact : {};
        const emailFlat =
          d.email
          ?? d.Email
          ?? d.buyerEmail
          ?? nested.email
          ?? nested.Email
          ?? '';
        return {
          companyName: nested.companyName || d.compname || d.buyerCompanyMasked || '',
          fullName: nested.fullName || nested.name || d.buyerNameMasked,
          jobTitle: nested.jobTitle || d.jobTitle,
          countryRegion: nested.countryRegion || d.countryRegion,
          mobile: nested.mobile || nested.tel || d.tel,
          email: emailFlat
        };
      },
      contactEmailDisplay() {
        const e = this.contact && this.contact.email;
        if (e != null && String(e).trim() !== '') return e;
        return '—';
      },
      contactPersonOptions() {
        return this.contactPersonOptionsData || [];
      },
      langId() {
        return localStorage.getItem('currentLangId') || '1252';
      },
      companyLogoUrl() {
        const d = this.LikeFollowDetail || {};
        const authUser = this.$store?.state?.authentication?.user || {};
        const u = this.user || {};
        return d.companyLogoUrl || d.companyLogo || u.companyLogo || u.logo || u.logoUrl || u.companyLogoUrl || authUser.companyLogo || authUser.logo || authUser.logoUrl || authUser.companyLogoUrl || '';
      },
      /** 无公司图片时展示首字，逻辑参考 InquiryForm DefaultCompanyfirstName */
      likedCompanyFirstChar() {
        if (!this.likedTarget || this.likedTarget.isProduct) return '';
        const name = this.likedTarget.name || '';
        const plain = String(name).replace(/<[^>]+>/g, '');
        const cleaned = plain.replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, '');
        if (cleaned.length) return cleaned[0];
        const t = plain.trim();
        if (t.length) return t[0];
        return '?';
      },
      replyModalLogoUrl() {
        // Reply modal now uses company-only header.
        const r = this.replyModalInfo || {};
        if (r.companyLogoUrl) return r.companyLogoUrl;
        if (this.companyLogoUrl) return this.companyLogoUrl;
        return '';
      },
      replyModalCompanyFirstChar() {
        const name = this.replyModalCompanyName || '';
        const plain = String(name).replace(/<[^>]+>/g, '');
        const cleaned = plain.replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, '');
        if (cleaned.length) return cleaned[0];
        const t = plain.trim();
        if (t.length) return t[0];
        return '?';
      },
      replyModalCompanyName() {
        const r = this.replyModalInfo || {};
        if (r.companyName) return r.companyName;
        const d = this.LikeFollowDetail || {};
        if (d.compname) return d.compname;
        const authUser = this.$store?.state?.authentication?.user || {};
        const u = this.user || {};
        return u.companyName || u.compName || u.compname || authUser.companyName || authUser.compName || authUser.compname || '---';
      },
      replyModalCompanyDesc() {
        const r = this.replyModalInfo || {};
        const years = Number(r.companyEstablishedYears || 0);
        const offices = Number(r.officeCount || 0);
        const categories = Number(r.productCategoryCount || 0);
        const businessNature = String(r.companyBusinessNature || '').trim();

        const i18nKey = 'lbl_EMPBE_SalesLead_LikeFollow_CompanyMetaTemplate';
        const i18nTemplate = this.$t(i18nKey);
        const metaTemplate = (typeof i18nTemplate === 'string' && i18nTemplate.trim() && i18nTemplate !== i18nKey)
          ? i18nTemplate
          : '{totalFoundYears} Years | {noOfOffices}+ Office(s) & Factory(ies) | {BusinessNature} | {noOfCategory} Categories Covered';
        if (
          (Number.isFinite(years) && years > 0)
          || (Number.isFinite(offices) && offices > 0)
          || (Number.isFinite(categories) && categories > 0)
          || businessNature
        ) {
          return String(metaTemplate || '')
            .replace('{totalFoundYears}', Number.isFinite(years) && years > 0 ? String(years) : '0')
            .replace('{totalFoundYear}', Number.isFinite(years) && years > 0 ? String(years) : '0')
            .replace('{noOfOffices}', Number.isFinite(offices) && offices > 0 ? String(offices) : '0')
            .replace('{noOfOffice}', Number.isFinite(offices) && offices > 0 ? String(offices) : '0')
            .replace('{noOfOfiices}', Number.isFinite(offices) && offices > 0 ? String(offices) : '0')
            .replace('{BusinessNature}', businessNature || '-')
            .replace('{businessNature}', businessNature || '-')
            .replace('{noOfCategory}', Number.isFinite(categories) && categories > 0 ? String(categories) : '0')
            .replace('{noOfCategories}', Number.isFinite(categories) && categories > 0 ? String(categories) : '0');
        }

        return (
          r.companyDescription
          || r.companySummary
          || r.profileSummary
          || r.companyIntro
          || r.companySlogan
          || ''
        );
      },
      canSendInvitation() {
        // Only disable when current booth is free and this record is explicitly not unlocked.
        if (!this.isUnlockQuotaBooth) return true;
        const isUnLockedValue = this.LikeFollowDetail?.isUnLocked;
        if (isUnLockedValue === 0 || isUnLockedValue === '0' || isUnLockedValue === false) {
          return false;
        }
        return true;
      },
      /** 发邀请按钮不带解锁额度数字；额度只在解锁横幅/弹窗展示 */
      sendInvitationBtnText() {
        return this.$t('lbl_EMPBE_SalesLead_LikeFollow_SendInvitation');
      },
      showContactHiddenHint() {
        // show hint when not accepted yet
        return this.actionStatusNormalized !== 'accept';
      },
      shouldShowRiskAlert() {
        const flag = this.LikeFollowDetail?.hasRiskAlert;
        return flag === true || flag === 1 || flag === '1';
      },
      isSendInvitationDisabled() {
        const isUnlocked = this.LikeFollowDetail?.isUnLocked === 1 || this.LikeFollowDetail?.isUnLocked === true || this.LikeFollowDetail?.isUnLocked === '1';
        return this.isUnlockQuotaBooth && this.isLockedByQuota && !isUnlocked;
      },
      /** eMarketplace 公司页分享链接（与 nameCard `companyShareUrl` 一致） */
      companyShareUrl() {
        const companyId = this.user?.empCompanyId || this.LikeFollowDetail?.empCompanyId;
        if (!companyId) return null;
        let langSegment = 'simp';
        switch (String(this.langId)) {
          case '950':
            langSegment = 'trad';
            break;
          case '1252':
            langSegment = 'eng';
            break;
          default:
            langSegment = 'simp';
            break;
        }
        const base = process.env.VUE_APP_EMP_VIEW || 'https://www.chinaplasonline.com/eMarketplace/';
        return `${base}ExhibitorInfo/${langSegment}?compid=${companyId}`;
      },
      /** 整块「点赞产品 / 关注公司」卡片跳转 URL（与 nameCard `leadSourceTargetUrl` 一致） */
      likedTargetTargetUrl() {
        return this.productShareUrl || this.companyShareUrl || null;
      }
    },
    watch: {
      rid() {
        this.isContactLocked = true;
      },
      messageToBuyer() {
        this.$nextTick(() => {
          this.updateMessageInputRows();
        });
      },
      showSendInvitationModal(v) {
        if (!v) {
          this.isMessageOverOneLine = false;
          return;
        }
        // b-modal 内容挂在 body 下，需等两帧再量高
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.updateMessageInputRows();
          });
        });
      }
    },
    methods: {
      /**
       * 取「给买家的留言」原生 textarea：b-modal 会把内容挂到 body，this.$el 里找不到；
       * 优先走 customtextarea → b-form-textarea 的 ref。
       */
      getSendInvitationMessageTextareaEl() {
        const ct = this.$refs.lfMessageToBuyerTextarea;
        try {
          if (ct && ct.$refs && ct.$refs.textarea) {
            const root = ct.$refs.textarea.$el;
            if (root && root.tagName === 'TEXTAREA') return root;
            if (root && typeof root.querySelector === 'function') {
              const inner = root.querySelector('textarea');
              if (inner) return inner;
            }
          }
        } catch (e) { /* ignore */ }
        const modal = document.getElementById('SendInvitationModal');
        if (modal) {
          return modal.querySelector('.lf-message-input textarea.form_textarea')
            || modal.querySelector('.lf-message-input textarea');
        }
        return this.$el ? this.$el.querySelector('.lf-message-input textarea') : null;
      },
      updateMessageInputRows() {
        try {
          const textareaEl = this.getSendInvitationMessageTextareaEl();
          if (!textareaEl) {
            this.isMessageOverOneLine = false;
            return;
          }
          const text = this.messageToBuyer || '';
          if (!String(text).trim()) {
            this.isMessageOverOneLine = false;
            return;
          }
          const hasExplicitNewline = text.indexOf('\n') !== -1 || text.indexOf('\r') !== -1;
          const lh = parseFloat(window.getComputedStyle(textareaEl).lineHeight) || 21;
          // 单行内容 scrollHeight 上限（与 padding 留余量）
          const oneLineScrollMax = Math.ceil(lh * 1.4) + 18;

          if (this.isMessageOverOneLine) {
            // 已展开为 5 行高时，不能再用 scrollHeight > clientHeight（会误判为单行并立刻收起）
            const collapse = !hasExplicitNewline && textareaEl.scrollHeight <= oneLineScrollMax;
            this.isMessageOverOneLine = !collapse;
            return;
          }
          // 收起态（单行 40px）：折行或换行则 scrollHeight 超过可视高度
          const overflowY = textareaEl.scrollHeight > textareaEl.clientHeight + 4;
          this.isMessageOverOneLine = hasExplicitNewline || overflowY;
        } catch (e) {
          this.isMessageOverOneLine = false;
        }
      },
      openLikedTargetLink() {
        if (!this.likedTargetTargetUrl) return;
        window.open(this.likedTargetTargetUrl, '_blank', 'noopener');
      },
      onLikeFollowUnlockQuota(isLockedByQuota) {
        // unlockQuota_Free convention: only true when "still locked && YearRemainingQuota == 0"
        this.isLockedByQuota = !!isLockedByQuota;
      },
      onLikeFollowUnlockQuotaInfo(quotaInfo) {
        this.bookmarkYearRemainingQuota = Number(quotaInfo?.yearRemainingQuota ?? 0);
        this.bookmarkEveryYearQuota = Number(quotaInfo?.everyYearQuota ?? 0);
        if (quotaInfo && typeof quotaInfo.isLock !== 'undefined') {
          this.isContactLocked = !!quotaInfo.isLock;
        }
      },
      openLikeFollowUnlockDialog() {
        const comp = this.$refs.likeFollowUnlockQuota;
        if (comp && typeof comp.OpenDialog === 'function') {
          comp.OpenDialog();
        }
      },
      onSendInvitation() {
        if (this.isSendInvitationDisabled) return;
        this.openSendInvitationModal();
      },
      onActionStatusClick() {
        this.openSendInvitationModal();
      },
      async openSendInvitationModal() {
        this.showSendInvitationModal = true;
        // No preset text: keep message empty when opening send-invitation modal.
        this.messageToBuyer = '';
        await this.fetchLikeFollowReplyInfo();
        await this.fetchContactPersonOptions();
      },
      async fetchLikeFollowReplyInfo() {
        if (this.replyModalInfoLoading) return;
        this.replyModalInfoLoading = true;
        try {
          const langId = parseInt(this.langId) || 1252;
          const detail = await InquiryFormService.GetLikeFollowReplyInfo({
            rid: this.rid,
            langId
          });
          this.replyModalInfo = detail || null;
        } catch (e) {
          console.error('Failed to fetch like/follow reply info:', e);
          this.replyModalInfo = null;
        } finally {
          this.replyModalInfoLoading = false;
        }
      },
      async fetchContactPersonOptions() {
        if (this.contactPersonLoaded || this.contactPersonLoading) return;
        this.contactPersonLoading = true;
        try {
          const langId = parseInt(this.langId) || 1252;
          const list = await InquiryFormService.GetNameCardReplyContacts(langId) || [];

          const storeUser = this.$store?.state?.authentication?.user || {};
          const currentAccountUserId =
                    storeUser?.accountUserId
                    || storeUser?.AccountUserId
                    || this.user?.accountUserId
                    || this.user?.AccountUserId
                    || this.user?.accountUserID
                    || this.user?.AccountUserID
          || 0;

          const arr = Array.isArray(list) ? list : [];
          const selfUser = arr.find(u => String(u?.accountUserId ?? u?.id) === String(currentAccountUserId));
          const selfId = selfUser ? String(selfUser?.accountUserId ?? selfUser?.id) : null;
          const eBoothRepresentativeIdRaw = arr.find(u => u?.eBoothRepresentativeId)?.eBoothRepresentativeId;
          const eBoothRepresentativeId =
            (eBoothRepresentativeIdRaw === null || eBoothRepresentativeIdRaw === undefined || eBoothRepresentativeIdRaw === '')
              ? null
              : String(eBoothRepresentativeIdRaw);

          const map = {};
          const options = [];

          arr.forEach((u) => {
            const key = String(u?.accountUserId ?? u?.id ?? u?.roleId ?? '');
            const label = u?.label || u?.displayName || u?.personName || u?.name || '';
            if (!key || !label) return;
            map[key] = u;
            options.push({ id: key, label });
          });

          // put current user first if exists（与名片回复一致）
          if (selfUser) {
            const selfKey = String(selfUser?.accountUserId ?? selfUser?.id);
            const withoutSelf = options.filter(x => String(x.id) !== selfKey);
            options.splice(0, options.length, { id: selfKey, label: selfUser.label || selfUser.displayName || '' }, ...withoutSelf);
          }

          this.contactPersonOptionsData = options;
          this.contactPersonMap = map;
          this.contactPersonLoaded = true;

          const validIds = new Set((options || []).map(o => String(o.id)));
          const current = String(this.selectedContactPerson || '');
          if (!current || !validIds.has(current)) {
            // 默认优先级与名片「回复」一致：展台代表 > 当前用户 > 列表首项
            if (eBoothRepresentativeId && validIds.has(eBoothRepresentativeId)) {
              this.selectedContactPerson = eBoothRepresentativeId;
            } else {
              this.selectedContactPerson = selfUser ? String(selfId) : (options[0]?.id ? String(options[0].id) : null);
            }
          }

          const suggested = String(this.replyModalInfo?.lastReplyRoleId || '');
          if (suggested && validIds.has(suggested)) {
            this.selectedContactPerson = suggested;
          }
        } catch (e) {
          console.error('Failed to fetch contact person options:', e);
          this.contactPersonOptionsData = [];
          this.contactPersonMap = {};
          this.contactPersonLoaded = true;
        } finally {
          this.contactPersonLoading = false;
        }
      },
      async confirmSendInvitation() {
        if (!this.selectedContactPerson) return;
        if (this.replySubmitting) return;
        const message = String(this.messageToBuyer || '').trim();
        if (!message) {
          const fieldLabel = this.$t('lbl_EMPBE_SalesLead_LikeFollow_MessageToBuyer');
          this.$swal({
            text: this.$t('lbl_EMPBE_FieldCannotBeEmpty', { field: fieldLabel }),
            showCancelButton: false,
            confirmButtonText: this.$t('lbl_EMPBE_Confirm'),
          });
          this.$nextTick(() => {
            try {
              const textarea = this.getSendInvitationMessageTextareaEl();
              if (textarea && typeof textarea.focus === 'function') textarea.focus();
            } catch (e) { /* ignore */ }
          });
          return;
        }
        const unlocked = await this.ensureLikeFollowUnlockedBeforeSend();
        if (!unlocked) return;
        if (this.saveAsDefaultMessage) {
          localStorage.setItem('likeFollow_defaultInvitationMessage', this.messageToBuyer || '');
        }
        this.replySubmitting = true;
        try {
          const payload = {
            bookmarkEventId: Number(this.rid || 0),
            roleId: Number(this.selectedContactPerson),
            replyMessage: this.messageToBuyer || '',
            langId: this.langId ? parseInt(this.langId) : null
          };
          const result = await InquiryFormService.ReplyLikeFollow(payload);
          if (typeof result === 'number' && result > 0) {
            this.showSendInvitationModal = false;
            await this.fetchLikeFollowReplyInfo();
            if (this.LikeFollowDetail && typeof this.LikeFollowDetail === 'object') {
              this.$set(this.LikeFollowDetail, 'status', 'Pending');
            }
            // 立即刷新左侧列表状态标签（待处理），不等整页重载
            this.$emit('invitation-sent', { rid: this.rid, status: 'Pending' });
            if (typeof this.GetDetail === 'function') {
              await this.GetDetail();
            }
          } else {
            // eslint-disable-next-line no-console
            console.error('ReplyLikeFollow failed with code:', result);
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error('ReplyLikeFollow error:', e);
        } finally {
          this.replySubmitting = false;
        }
      },
      async ensureLikeFollowUnlockedBeforeSend() {
        const isUnLockedValue = this.LikeFollowDetail?.isUnLocked;
        const needUnlock = this.isUnlockQuotaBooth && (isUnLockedValue === 0 || isUnLockedValue === '0' || isUnLockedValue === false);
        if (!needUnlock) return true;
        if (this.simulatedSupplier) return true;
        if (!this.user?.empCompanyId || !this.rid) return false;

        try {
          const param = {
            EmpCompanyId: this.user.empCompanyId,
            UnlockType: 'Bookmark',
            RelatedRID: this.rid,
            URL: window.location.href,
            BAgent: window.navigator.userAgent
          };
          const res = await InquiryFormService.AddUnlockQuotaFree(param);
          if (!res?.isSuccessful) return false;

          if (this.LikeFollowDetail && typeof this.LikeFollowDetail === 'object') {
            this.$set(this.LikeFollowDetail, 'isUnLocked', 1);
          }
          this.isLockedByQuota = false;
          this.unlockQuotaRefreshKey += 1;
          if (typeof this.GetDetail === 'function') {
            await this.GetDetail();
          }
          return true;
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error('AddUnlockQuotaFree failed in like/follow:', e);
          return false;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
/* Copy the key layout styles from NameCard detail to keep Like/Follow truly consistent */
.lf-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-self: stretch;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
}

.lf-remarks {
    align-self: stretch;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
}

.lf-tray {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 24px;
    background: #FFFFFF;
    box-shadow: 0px 2px 15px 0px rgba(183, 183, 183, 0.30);
    padding: 24px;
}

.lf-mobile {
    border-radius: 0;
    box-shadow: none;
    padding: 0;
}

/* 手机：标题区纵向排列，避免左右挤压导致逐字竖排 */
.lf-mobile .lf-title-row {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
}

.lf-mobile .lf-title-left {
    flex: 0 0 auto;
    width: 100%;
    max-width: 100%;
}

.lf-mobile .lf-title-line {
    flex: 1 1 auto;
    width: 100%;
}

.lf-mobile .lf-title-right {
    width: 100%;
    flex: 0 0 auto;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 2px;
}

.lf-mobile .lf-title-text {
    flex: 1 1 auto;
    width: 100%;
    overflow-wrap: break-word;
    word-break: break-word;
}

.lf-mobile .lf-received,
.lf-mobile .lf-ref {
    width: 100%;
    text-align: left;
}

/* Super admin (simulatedSupplier) should also use mobile-like vertical layout */
.lf-mobile .lf-content-inner {
    grid-template-columns: 1fr;
}

.lf-mobile .lf-contact,
.lf-mobile .lf-master {
    min-width: 0;
    width: 100%;
    max-width: 100%;
}

.lf-title-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    align-self: stretch;
    min-width: 0;
    max-width: 100%;
}

.lf-title-left {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1 1 0;
    min-width: 0;
    max-width: 100%;
}

.lf-back {
    width: 24px;
    height: 24px;
    cursor: pointer;
    display: inline-flex;
}

.lf-title-line {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    min-width: 0;
    max-width: 100%;
}

.lf-title-text {
    color: rgba(0, 0, 0, 0.80);
    font-family: Inter, sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 150%;
    letter-spacing: -0.22px;
    min-width: 0;
    max-width: 100%;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
}

.lf-unread-chip {
    display: flex;
    padding: 2px 8px;
    justify-content: center;
    align-items: center;
    border-radius: 125px;
    background: #7366FF;
    color: #FFFFFF;
    font-family: Inter, sans-serif;
    font-size: 13px;
    font-weight: 600;
    line-height: 150%;
    flex-shrink: 0;
}

.lf-viewed {
    color: rgba(0, 0, 0, 0.50);
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 30px;
    white-space: nowrap;
    flex-shrink: 0;
}
.lf-viewed.is-unlocked {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 125px;
    background: #37B400;
    color: #FFFFFF;
    font-size: 13px;
    font-weight: 600;
    line-height: 150%;
}
.lf-viewed__lock {
    display: block;
    flex-shrink: 0;
    width: 15px;
    height: 16px;
}

.lf-title-right {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;
    flex-shrink: 0;
}

.lf-visibility-tip {
    display: inline-flex;
    align-items: center;
    line-height: 1;
    margin-top: 2px;
}
.lf-visibility-tip ::v-deep .TipsAndPrivewDilog__icon {
    margin-left: 0;
    color: rgba(0, 0, 0, 0.55);
    font-size: 14px;
    cursor: help;
}

.lf-received {
    color: rgba(0, 0, 0, 0.80);
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
}

.lf-ref {
    color: rgba(0, 0, 0, 0.40);
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 150%;
}

.lf-unlock {
    width: 100%;
}

.lf-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
    min-width: 0;
    max-width: 100%;
    padding: 8px 16px;
    border-radius: 16px;
    background: #F2F3F5;
}

.lf-content-inner {
    display: grid;
    /* 默认单列：窄屏/无 container 时都不会双栏挤扁；够宽再并排 */
    grid-template-columns: 1fr;
    gap: 16px;
    align-self: stretch;
    padding: 8px 0px;
    min-width: 0;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
}

/* 详情区够宽才左右并排 */
@container (min-width: 1001px) {
    .lf-content-inner {
        grid-template-columns: minmax(0, 1fr) minmax(260px, min(420px, 100%));
    }
}

.lf-master {
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: 0;
    max-width: 100%;
    width: 100%;
}

.lf-section {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.lf-section-title {
    color: rgba(0, 0, 0, 0.80);
    font-family: Inter, sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 150%;
}

.lf-card-legacy {
    display: flex;
    flex-direction: column;
    padding: 20px;
    gap: 16px;
    align-self: stretch;
    background: #FFFFFF;
    border: 1px solid #F2F3F5;
    border-radius: 8px;
}

.lf-contact {
    min-width: 0;
    max-width: 100%;
    width: 100%;
}

.lf-contact-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-self: stretch;
    min-width: 0;
    max-width: 100%;
}

.lf-row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    min-width: 0;
    max-width: 100%;
}

.lf-row-label {
    width: 140px;
    color: rgba(0, 0, 0, 0.40);
    font-family: Inter, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
    flex: 0 0 auto;
}

.lf-row-value {
    color: rgba(0, 0, 0, 0.80);
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.5;
    flex: 1 1 0;
    min-width: 0;
    max-width: 100%;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
}

/* Like/Follow cards inside content */
.lf-card {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    background: #FFFFFF;
    border: 1px solid #F2F3F5;
    border-radius: 8px;
}
/* 与 nameCard `.nc-card--clickable` 一致：整块可点 + hover */
.lf-card--clickable {
    cursor: pointer;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.lf-card--clickable:hover {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    transform: translateY(-1px);
}
.lf-product {
    display: flex;
    gap: 16px;
    text-decoration: none;
    color: inherit;
    align-items: center;
}
.lf-product-thumb {
    width: 96px;
    height: 96px;
    border-radius: 6px;
    overflow: hidden;
    background: #F9F9F9;
    border: 0.5px solid rgba(0, 0, 0, 0.05);
    flex: 0 0 auto;
}
.lf-product-thumb--company {
    border-radius: 999px;
}
.lf-company-thumb-fallback {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: rgba(0, 0, 0, 0.2);
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.5;
    letter-spacing: -0.264px;
}
.lf-product-thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
.lf-product-title {
    display: flex;
    gap: 8px;
    align-items: center;
    min-width: 0;
    flex: 1 1 auto;
}
.lf-product-title-text {
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    min-width: 0;
    max-width: 100%;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
}
.lf-product-external {
    color: rgba(0, 0, 0, 0.4);
    flex: 0 0 auto;
}

.lf-actions-desc {
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    align-self: stretch;
    min-width: 0;
    max-width: 100%;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
}
.lf-actions-row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    width: 100%;
}
.lf-actions-slash {
    color: rgba(0, 0, 0, 0.2);
    font-size: 14px;
    font-weight: 400;
    line-height: 130%;
    flex-shrink: 0;
}
.lf-actions-tip {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    font-weight: 400;
    line-height: 130%;
    min-width: 0;
    flex: 1 1 200px;
}
.lf-actions-btn {
    align-self: flex-start;
    background: #7968FF;
    border: 1px solid #7968FF;
    color: #FFFFFF;
    border-radius: 4px;
    padding: 8px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.5;
    letter-spacing: -0.154px;
    cursor: pointer;
    flex-shrink: 0;
    white-space: nowrap;
}
.lf-actions-btn:hover:not(:disabled) {
    background: #4433FF;
    border-color: #4433FF;
}
.lf-actions-btn:disabled {
    background: #9EA5A8;
    border-color: #9EA5A8;
    color: #FFFFFF;
    opacity: 1;
    cursor: not-allowed;
}

/* 额度用尽锁定：与无额度横幅同色 */
.lf-actions-btn.lf-actions-btn-no-quota:disabled {
    border: none;
    background: radial-gradient(
        ellipse 241.8% 251.52% at 102.83% 124.79%,
        #FFD631 0%,
        #FF7931 14%,
        #9554E2 45%,
        #8550FF 75%,
        #6231FF 100%
    );
}

.lf-actions-btn-unlock {
    border: none;
}
.lf-actions-btn-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
}
.lf-actions-btn-icon img {
    filter: brightness(0) invert(1);
}

.lf-actions-meta {
    margin-top: 6px;
    color: rgba(0, 0, 0, 0.4);
    font-family: Inter, sans-serif;
    font-size: 12px;
    line-height: 1.3;
    min-width: 0;
    max-width: 100%;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
}

.lf-actions-btn-status {
    margin-top: 8px;
    cursor: pointer;
    min-width: 132px;
    justify-content: center;
}
.lf-actions-btn-status:disabled {
    cursor: default;
}

.lf-status-icon {
    width: 20px;
    height: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    color: #FFFFFF;
}

.lf-status-icon img {
    filter: brightness(0) invert(1);
}

.lf-status-text {
    min-width: 0;
    max-width: 100%;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
}

.lf-status-pending {
    background: #FFD02C;
    border-color: #FFD02C;
    color: rgba(0, 0, 0, 0.8);
}
.lf-status-pending .lf-status-icon img {
    filter: brightness(0) saturate(100%);
}
.lf-status-pending:hover:not(:disabled) {
    background: #E6BB1A;
    border-color: #E6BB1A;
}

.lf-status-accept {
    background: #51BB25;
    border-color: #51BB25;
    color: #FFFFFF;
}
.lf-status-accept:hover:not(:disabled) {
    background: #5ED62C;
    border-color: #5ED62C;
}

.lf-status-reject {
    background: #9B9B9B;
    border-color: #9B9B9B;
    color: #FFFFFF;
}










.lf-status-reject:hover:not(:disabled) {
    background: #8A8A8A;
    border-color: #8A8A8A;
}

.lf-contact-tip {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
    padding: 10px 12px;
    border-radius: 4px;
    background: #FFF4CC;
}

.lf-contact-tip__icon {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    margin-top: 1px;
    color: rgba(0, 0, 0, 0.65);
}

.lf-contact-tip__text {
    flex: 1 1 auto;
    min-width: 0;
    color: rgba(0, 0, 0, 0.80);
    font-family: Inter, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
}

.lf-contact-foot {
    align-self: stretch;
    color: rgba(0, 0, 0, 0.40);
    font-family: Inter, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
    padding-top: 16px;
    border-top: 1px solid #F2F3F5;
}

.lf-risk-note {
    border-radius: 8px;
    background: #FFD43A;
    padding: 16px;
}

.lf-risk-note-title {
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-weight: 700;
  line-height: 18.20px;
  word-wrap: break-word
}

.lf-risk-note-text {
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-weight: 400;
  line-height: 18.20px;
  word-wrap: break-word
}

.lf-risk-note-modal {
    margin-bottom: 2px;
}

@media screen and (max-width: 768px) {
    .lf-content-inner {
        grid-template-columns: 1fr;
    }

    .lf-contact,
    .lf-master {
        min-width: 0;
        width: 100%;
        max-width: 100%;
    }
}

/* ===== Modal (mirror NameCard modal styles) ===== */
.lf-modal-title-text {
    color: rgba(0, 0, 0, 0.80);
    font-size: 18px;
    font-weight: 700;
    line-height: 130%;
}

.lf-modal-record-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    padding-right: 40px;
}

.lf-modal-record-main {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.lf-modal-status-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.5;
    color: #fff;
    background: #9EA5A8;
}

.lf-modal-status-tag.lf-status-accept {
    background: #51BB25;
}

.lf-modal-status-tag.lf-status-pending {
    background: #FFD02C;
    color: rgba(0, 0, 0, 0.8);
}

.lf-modal-status-tag.lf-status-reject {
    background: #9B9B9B;
}

.lf-modal-title {
    display: flex;
    flex-direction: column;
    gap: 4px;
    position: relative;
    padding-right: 40px;
}

.lf-modal-close {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 32px;
    height: 32px;
    padding: 4px;
    border: none;
    background: transparent;
    cursor: pointer;
}

.lf-modal-subtitle {
    color: rgba(0, 0, 0, 0.60);
    font-size: 14px;
    font-weight: 400;
    line-height: 130%;
}

.lf-modal-body {
    display: flex;
    flex-direction: column;
    gap: 16px;
    color: rgba(0, 0, 0, 0.80);
}

.lf-modal-block {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.lf-modal-label {
    color: rgba(0, 0, 0, 0.40);
    font-size: 12px;
    font-weight: 400;
    line-height: 150%;
}

.lf-modal-hint {
    color: rgba(0, 0, 0, 0.40);
    font-size: 12px;
    line-height: 150%;
}
 ::v-deep .lf-modal-block .form-control{
  font-size: 14px !important;
}
.lf-modal-info-note {
    margin-top: 12px;
    color: rgba(0, 0, 0, 0.40);
    font-size: 12px;
    line-height: 150%;
}

.lf-modal-link {
    color: #2C6ECB;
    text-decoration: none;
    margin-left: 4px;
}

.lf-modal-hint .lf-modal-link,
.lf-modal-info-note .lf-modal-link {
    margin-left: 0;
}

.lf-modal-link:hover {
    text-decoration: none;
}

.lf-modal-profile {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.lf-modal-profile-title {
    color: rgba(0, 0, 0, 0.8);
    font-size: 14px;
    font-weight: 700;
    line-height: 130%;
}

.lf-modal-profile-card {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    border: 1px solid #F2F3F5;
    border-radius: 8px;
    background: #FFFFFF;
}

.lf-modal-profile-left {
    flex: 0 0 auto;
}

.lf-modal-logo {
    width: 96px;
    height: 96px;
    border-radius: 999px;
    overflow: hidden;
    border: 0.5px solid rgba(0, 0, 0, 0.05);
    background: #FFFFFF;
}

.lf-modal-logo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.lf-modal-logo-fallback {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(0, 0, 0, 0.2);
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    line-height: 150%;
    letter-spacing: -0.264px;
}

.lf-modal-profile-right {
    flex: 1 1 auto;
    min-width: 0;
}

.lf-modal-company {
    color: rgba(0, 0, 0, 0.8);
    font-size: 16px;
    font-weight: 700;
    line-height: 130%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.lf-modal-company-desc {
    margin-top: 8px;
    color: rgba(0, 0, 0, 0.6);
    font-size: 12px;
    font-weight: 400;
    line-height: 130%;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.lf-modal-save {
    margin-top: 4px;
}

.lf-modal-readonly-title {
    margin-bottom: 8px;
    color: rgba(0, 0, 0, 0.6);
    font-size: 12px;
    line-height: 1.3;
}

.lf-modal-readonly-value {
    min-height: 88px;
    padding: 12px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.16);
    background: rgba(0, 0, 0, 0.03);
    font-size: 14px;
    line-height: 1.6;
    white-space: pre-wrap;
    word-break: break-word;
}


/* Sync ModalTips footer buttons styles (same as NameCard, keep scoped) */
.UserSetting_Ok {
    padding: 15px 16px !important;
    line-height: 1.5 !important;
    border-radius: 0.25rem !important;
    font-size: 14px !important;
    font-family: Inter, sans-serif !important;
    font-weight: 700 !important;
    box-shadow: none !important;
    border: none !important;
    background: #7366FF !important;
}

.UserSetting_Ok:hover:not(:disabled) {
    background: #4433FF !important;
}

.UserSetting_Ok:focus,
.UserSetting_Ok:active {
    box-shadow: none !important;
}

.UserSetting_Ok:disabled,
.UserSetting_Ok.disabled {
    background: #9EA5A8 !important;
    opacity: 1 !important;
    cursor: not-allowed !important;
}

/* 默认一行；超过一行时加 .lf-message-input--expanded，固定约 5 行可视高度 */
::v-deep .lf-message-input .form_textarea {
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    line-height: 1.5 !important;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    resize: none !important;
    overflow-y: auto !important;
    box-sizing: border-box !important;
}

::v-deep .lf-message-input--expanded .form_textarea {
    height: 120px !important;
    min-height: 120px !important;
    max-height: 200px !important;
}

::v-deep .lf-message-input .word-count {
    display: none !important;
}

.UserSetting_Cancel {
    padding: 15px 24px !important;
    line-height: 1.5 !important;
    border-radius: 0.25rem !important;
    border: none !important;
    background: transparent !important;
    color: rgba(0, 18, 26, 0.60) !important;
    font-size: 14px !important;
    font-family: Inter, sans-serif !important;
    font-weight: 700 !important;
    text-decoration: none !important;
    box-shadow: none !important;
}

.UserSetting_Cancel:hover:not(:disabled):not(.disabled),
.UserSetting_Cancel:focus:not(:disabled):not(.disabled),
.UserSetting_Cancel:active:not(:disabled):not(.disabled) {
    background: rgba(0, 18, 26, 0.05) !important;
    color: rgba(0, 18, 26, 0.60) !important;
    text-decoration: none !important;
    border: none !important;
    box-shadow: none !important;
}

.UserSetting_Cancel:disabled,
.UserSetting_Cancel.disabled {
    background: transparent !important;
    cursor: not-allowed !important;
    opacity: 0.6 !important;
}

.lf-mobile .lf-card,
.lf-mobile .lf-unlock,
.lf-remarks ::v-deep .message-thread {
    box-shadow: 0 2px 15px 0 rgba(183, 183, 183, 0.3);
}
</style>

